import React, { useEffect, useState } from 'react'
import { useUpdateQuestionAnswerReasoningMutation } from '../../../../../../../../../../store/apis/submission.api'
import ManualSaveTextArea from './ManualSaveTextArea'
import { useThemeColors } from '../../../../../../../../../../hooks/useThemeColors'

const ReasoningInput = ({
    submissionId,
    answerId,
    initialValue,
    readonly,
    isRequired = false,
    questionRubricId,
    isDraftMode = false,
    onDraftChange,
    applyDraft,
    onCurrentValueChange,
}) => {
    const [updateQuestionAnswerReasoning, updateQuestionAnswerReasoningResult] =
        useUpdateQuestionAnswerReasoningMutation()
    const [isFocused, setIsFocused] = useState(false)
    const [currentValue, setCurrentValue] = useState(initialValue || '')
    const colors = useThemeColors()

    useEffect(() => {
        setCurrentValue(initialValue || '')
    }, [initialValue])

    const handleSave = reasoning => {
        updateQuestionAnswerReasoning({
            id: answerId,
            submissionId,
            reasoning,
            questionRubricId,
            feedbackType: 'personalized',
        })
    }

    const handleValueChange = value => {
        setCurrentValue(value)
        onCurrentValueChange?.(value)
        if (isDraftMode) onDraftChange?.(value)
    }

    const hasValue = currentValue.length > 0
    const showValidationError = isRequired && !hasValue && !isFocused

    return (
        <div className={`inline-label-wrapper ${readonly ? 'readonly' : ''} ${showValidationError ? 'has-error' : ''}`}>
            <div className='inline-label-textarea'>
                <span className='inline-label-text'>
                    Personalized Feedback:{isRequired && <span style={{ color: colors.error }}> *</span>}
                </span>
                <ManualSaveTextArea
                    initialValue={initialValue}
                    onSave={handleSave}
                    isLoading={updateQuestionAnswerReasoningResult.isLoading}
                    readonly={readonly}
                    placeholder='Enter personalized feedback for this grade...'
                    className='reasoning inline-label-input'
                    title='Personalized Feedback'
                    status={showValidationError ? 'error' : undefined}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    onValueChange={handleValueChange}
                    showButtons={!isDraftMode}
                    data-test='personalized-feedback-textarea'
                    applyDraft={applyDraft}
                />
            </div>
            {showValidationError && (
                <div style={{ color: colors.error, fontSize: '14px', marginTop: '4px' }}>
                    Personalized feedback is required and cannot be empty
                </div>
            )}
        </div>
    )
}

export default ReasoningInput
